// component when one time task is selected from dropdown
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DatePickerValue from '../DatePicker/DatePicker';

interface IOneTimeTaskProps {
  oneTimeData: {
    startDate: string | null;
  };
  handleOneTimeChange: (_field: string, _value: string) => void;
}

function OneTimeTask({ oneTimeData, handleOneTimeChange }: IOneTimeTaskProps) {
  const { t } = useTranslation();
  return (
    <Box mt="16px">
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="meta">
              {t('activity.assignActivity.oneTimeTaskDateInput.startDateLabel')}
            </Typography>
            <DatePickerValue
              date={oneTimeData.startDate ? oneTimeData.startDate : ''}
              handleOneTimeChange={(_, value) => handleOneTimeChange('startDate', value)}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default OneTimeTask;
